import { render, staticRenderFns } from "./product-filter.vue?vue&type=template&id=5a8a109c&scoped=true&"
import script from "./product-filter.vue?vue&type=script&lang=js&"
export * from "./product-filter.vue?vue&type=script&lang=js&"
import style0 from "./product-filter.vue?vue&type=style&index=0&id=5a8a109c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a109c",
  null
  
)

export default component.exports